import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOshkoshComponent } from './simple-icons-oshkosh.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOshkoshComponent ],
    exports:      [ SimpleIconsOshkoshComponent ],
    bootstrap:    []
})
export class SimpleIconsOshkoshModule {}
